<template>
  <div class="search-container">
    <div class="p-grid">
      <div class="p-col">
        <div class="p-input-icon-right search-input">
          <i
            class="pi pi-search"
            style="left: 0.5rem !important"
            v-if="!chips.length"
          />
          <i style="cursor: pointer" />
          <Chips
            type="text"
            style="width: 100%"
            :class="[
              {
                'search-input-placeholder-active': !chips.length,
              },
            ]"
            :placeholder="!chips.length ? 'Pesquisar' : ''"
            separator=","
            :modelValue="chips"
            @keyup.enter="search()"
            @add="addTerm($event)"
            @remove="removeChip($event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'debounce';

const getInitialValues = () => ({ term: [] });

export default {
  name: 'AppSearchBar',
  data() {
    return {
      values: getInitialValues(),
      valuesNames: { term: 'Termo' },
      chips: [],
    };
  },
  methods: {
    getChipValue(field, value) {
      return `${this.valuesNames[field]}: ${value}`;
    },
    addTerm({ value }) {
      const term = value
        .filter((v) => !v.includes(': ') || v.includes('Termo: '))
        .map((v) => v.replace('Termo: ', ''));
      this.values.term = term;
    },
    removeChip(event) {
      const [name, value] = event.value[0].split(': ');
      const field = Object.keys(this.valuesNames).find(
        (key) => this.valuesNames[key] === name
      );
      if (field === 'term') {
        this.values.term = this.values.term.filter((t) => t !== value);
      }
      this.search();
    },
    buildQuery() {
      const query = {};
      const chips = [];
      if (this.values.term) {
        query.term = this.values.term;
        chips.push(
          ...this.values.term.map((term) => this.getChipValue('term', term))
        );
      }
      return { query, chips };
    },
    search: debounce(
      function search() {
        const { query, chips } = this.buildQuery();
        this.chips = chips;
        this.$emit('search', { query });
      },
      500,
      true
    ),
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  ::v-deep .p-overlaypanel {
    left: 0 !important;
  }
}

.search-option-icon {
  font-size: 18px;
  color: #495057;
}

.search-input {
  width: 100%;

  ::v-deep .p-chips-multiple-container {
    width: 100%;
    display: inline;
  }
}

.search-input-placeholder-active {
  ::v-deep input {
    padding-left: 1.5rem !important;
  }
}

.search-order {
  button {
    background-color: white;
  }
}
</style>
